export const STRINGS = {
  back: 'BACK',
  'bi-weekly': 'Bi-Weekly',
  'book-a-pro': 'BOOK A PRO',
  'disabled-services':
    'This service may be a requirement in your lease to keep your home in good condition. Contact your Concierge with any questions about canceling.',
  'frequency-question': 'How frequently would you like us to perform this?',
  est: 'Est.',
  pricing: 'Pricing',
  'estimated-date': 'Estimated Date',
  'extras-question': 'Is there anything we should know? (Optional)',
  less: 'Less',
  'maintenance-budget': 'Yearly Maintenance Est.',
  monthly: 'Monthly',
  more: 'More',
  'non-recurring-title': 'Repairs, Upgrades & More',
  'no-recurring-services': 'No Routine Pro Services',
  'no-tasks': 'No tasks',
  off: 'OFF',
  on: 'ON',
  'per-visit': 'per visit',
  'pricing-tbd': 'TBD',
  recommended: 'Recommended',
  'recurring-title': 'Routine Pro Services',
  'request-an-upgrade': 'REQUEST AN UPGRADE',
  'resident-banner':
    "You don't need to lift a finger. We will handle communication with the resident.",
  responsibility: 'Responsibility',
  'select-home': 'Which home?',
  'show-completed': 'SHOW COMPLETED',
  'show-turned-off': 'SHOW TURNED OFF',
  'starting-from': 'Starting From',
  show: 'Show',
  unit: 'Unit',
  'unique-needs': 'Unique Needs',
  weekly: 'Weekly',
  'which-home': 'Which home?',
  addTitle: 'Request A Pro!',
  'add-title-homeowner': 'Increase ROI',
  'add-subtitle-homeowner': 'The 1% Rule',
  'add-body-homeowner':
    "Data suggests that to maximize home appreciation, you should spend around 1% of your home's value on annual upkeep.",
  'add-title-resident': 'Make Your Home Sparkle',
  'add-subtitle-resident': `Even More Magic In The\u00a0Belong App`,
  'add-body-resident':
    'Download and use the app to submit and stay up to date on pro\u00a0service tickets.',
  'pristine-home': 'A Pristine Home',
  'get-settled': 'Get Settled In',
  'not-too-hot': 'Not Too Hot Or Too Cold',
  'latest-tech': 'The Latest Home Tech',
  preventative: 'Preventative',
  'home-services': 'Home Services',
  'all-visits': 'Notes For All Visits',
  'special-requests': 'Notes For This Visit',
  delete: 'DELETE',
  add: 'ADD',
  save: 'SAVE',
  edit: 'EDIT',
  'submitted-pro-service':
    'We received your request. Your Homecare Specialist will reach out soon.',
  'updated-pro-service': 'Your request was successfully updated.',
  'turn-off-recurring': "Updated. You'll no longer receive this service.",
  'change-frequency': 'Your request was successfully updated.',
  'appointment-too-soon':
    'Contact your Concierge about cancelling because this visit is occurring in < 24 hrs.',
  'single-visit-cancelled': 'Cancelled the next visit.',
  'single-visit-cancelled-date': 'Cancelled the next visit. We will resume',
  around: 'around',
  'submit-request': 'Request A Pro',
  'create-repair': 'Repair Something',
  'create-upgrade': 'Request Upgrade',
  'edit-request': 'Edit Pro Service Request',
};
